import parentApi from '../../../store/parentApi';
import { convertQueryObjToString } from '../../../utility/urlQuery';
import {
  regaAdLicensesSummaryTransformer,
  regaAdLicensesListTransformer,
  regaAdLicenseDetailTransformer,
} from '../transformers/regaAdLicenses';

const BASE_URL = '/api/surge/rega_ad_licenses';

// Callers pass the final param names directly (page, per_page, q[...]), matching
// the ransack allowlist on the backend. Empty params are dropped by
// convertQueryObjToString, and the q[s] sort value is encoded.
const buildListQueryString = (params = {}) => {
  const normalized = { ...params };
  if (normalized['q[s]']) {
    normalized['q[s]'] = encodeURIComponent(normalized['q[s]']);
  }
  return convertQueryObjToString(normalized);
};

const regaAdLicensesApis = parentApi.injectEndpoints({
  endpoints: (build) => ({
    getRegaAdLicensesSummary: build.query({
      query: ({ userId } = {}) => {
        const queryString = userId ? convertQueryObjToString({ user_id: userId }) : '';
        return { url: queryString ? `${BASE_URL}/summary?${queryString}` : `${BASE_URL}/summary` };
      },
      transformResponse: (response) => regaAdLicensesSummaryTransformer(response),
      providesTags: ['rega-ad-license-summary'],
    }),
    getRegaAdLicenses: build.query({
      query: (params = {}) => {
        const queryString = buildListQueryString(params);
        return { url: queryString ? `${BASE_URL}?${queryString}` : BASE_URL };
      },
      transformResponse: (response) => regaAdLicensesListTransformer(response),
      providesTags: ['rega-ad-licenses'],
    }),
    getRegaAdLicenseDetail: build.query({
      query: (id) => ({ url: `${BASE_URL}/${id}` }),
      transformResponse: (response) => regaAdLicenseDetailTransformer(response),
    }),
    requestRegaAdLicenseAssistance: build.mutation({
      query: () => ({ url: `${BASE_URL}/request_assistance`, method: 'POST' }),
      // Invalidate unconditionally so a 422 ("already requested") also re-syncs the UI.
      invalidatesTags: ['rega-ad-license-summary'],
    }),
  }),
});

export const {
  useGetRegaAdLicensesSummaryQuery,
  useGetRegaAdLicensesQuery,
  useLazyGetRegaAdLicensesQuery,
  useGetRegaAdLicenseDetailQuery,
  useRequestRegaAdLicenseAssistanceMutation,
} = regaAdLicensesApis;

export default regaAdLicensesApis;
